import React from "react";
import "./Certifications.scss";
import certifications from "../data/certifications";
import useInView from "../hooks/useInView";

// 참고 형식: 이름 + 취득일의 단순한 행. 데이터는 중요도 순으로 이미 정렬되어 있다.
const EXTRAS = [
  {
    id: "award-kdigital",
    kind: "Award",
    name: "2026 K-디지털 트레이닝 해커톤 기술혁신상",
    date: "2026.08",
    note: "고용노동부 · 직업능력심사평가원",
  },
  {
    id: "award-ssafy-common",
    kind: "Award",
    name: "삼성청년SW·AI아카데미 공통 프로젝트 우수상",
    date: "2026.08",
    note: "삼성청년SW·AI아카데미",
  },
  {
    id: "award-ssafy-ai",
    kind: "Award",
    name: "2026 SSAFY AI 챌린지 최우수상",
    date: "2026.04",
    note: "재활용품 이미지 기반 질의응답 모델 개발 · 삼성청년SW·AI아카데미",
  },
  {
    id: "lang-toeic-speaking",
    kind: "Language",
    name: "TOEIC Speaking IM3 (130)",
    date: "2026",
  },
];

function Certifications() {
  const [ref, inView] = useInView();

  return (
    <section className="section certificates" id="certifications" ref={ref}>
      <div className="container">
        <h2 className={`section-title reveal ${inView ? "is-in" : ""}`}>
          Certificates
        </h2>

        <ul className={`cert-rows reveal ${inView ? "is-in" : ""}`}>
          {certifications.map((cert) => (
            <li className="cert-row" key={cert.id}>
              <span className="cert-name">{cert.name}</span>
              <span className="cert-date">
                {cert.date.replace("년 ", ".").replace("월", "").replace(/\.(\d)$/, ".0$1")}
              </span>
            </li>
          ))}

          {EXTRAS.map((item) => (
            <li className="cert-row is-extra" key={item.id}>
              <span className="cert-name">
                <i className="cert-kind">{item.kind}</i>
                {item.name}
                {item.note && <small>{item.note}</small>}
              </span>
              <span className="cert-date">{item.date}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default Certifications;
